import { forwardRef, useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import es from 'date-fns/locale/es';
import { registerLocale } from 'react-datepicker';
import { format } from 'date-fns';

registerLocale('es', es);

interface BirthDateProps {
    handleChangeBirthDate(value: string): unknown;
    birthDateProfile?: string;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function DatePickerComponent(props: BirthDateProps): JSX.Element {
    const { handleChangeBirthDate, birthDateProfile } = props;
    const [startDate, setDate] = useState(
        birthDateProfile !== '' && birthDateProfile !== 'null' && birthDateProfile !== null
            ? new Date(birthDateProfile)
            : new Date(),
    );

    const [birthDateApi, setBirthDateApi] = useState('');

    const defaultEndDate = new Date();
    defaultEndDate.setDate(defaultEndDate.getDate() + 7);

    const selectDateHandler = (d) => {
        setDate(d);
        setBirthDateApi(format(new Date(d), 'Y/MM/dd'));
    };

    useEffect(() => {
        if (birthDateApi) {
            handleChangeBirthDate(birthDateApi);
        }
    }, [birthDateApi]);

    const CustomInput = forwardRef<
        HTMLInputElement,
        React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>
    >((props, ref) => (
        <label className="relative text-gray-400 focus-within:text-gray-600 block">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                className="pointer-events-none w-8 h-8 absolute top-1/2 transform -translate-y-1/2 pb-1 right-3"
                viewBox="0 0 20 20"
                fill="currentColor"
            >
                <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
            </svg>
            <input
                ref={ref}
                {...props}
                className={`form-input p-4 border-2 rounded-xl border-gray-300 shadow-profile mb-2 py-3 bg-white placeholder-gray-400 text-gray-500 appearance-none w-full block pr-14 focus:outline-none`}
            />
        </label>
    ));

    return (
        <DatePicker
            customInput={<CustomInput />}
            selected={startDate}
            locale="es"
            onChange={selectDateHandler}
            dateFormat="dd/MM/yyyy"
            key="birthDate"
            peekNextMonth
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            placeholderText="selecciona tu fecha de Nacimiento"
        />
    );
}
